export default "__VITE_ASSET__CSMiALPa__"